<template>
  <Select
    class="pet-type-selector__select"
    :placeholder="placeholder"
    :is-disabled="isDisabled"
    :value="selectedPetTypeId"
    :options="petTypeOptions"
    :empty-text="emptyStateText"
    value-key="id"
    label-key="value"
    :error-messages="errorMessages"
    @beforeChange="onBeforeChange"
    @change="handlePetTypeSelect"
  />
</template>

<script>
import { petTypeLabels } from '@/entities/insurance/config/pet-types';
import { Select } from '@/shared/ui/form';

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Оберіть тип тварини',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedPetTypeId: null,
    };
  },
  mounted() {
    this.syncSelectedPetTypeId(this.value);
  },
  components: { Select },
  computed: {
    petTypeOptions() {
      return Object.entries(petTypeLabels).map(([id, value]) => ({ id, value }));
    },
  },
  methods: {
    extractId(rawValue) {
      const raw = typeof rawValue === 'object' ? rawValue?.id : rawValue;
      return raw != null ? String(raw) : null;
    },
    syncSelectedPetTypeId(newValue) {
      this.selectedPetTypeId = this.extractId(newValue);
    },
    handlePetTypeSelect(selectedId) {
      const normalizedId = this.extractId(selectedId);
      this.selectedPetTypeId = normalizedId;
      this.$emit('input', normalizedId);
      this.$emit('change', normalizedId);
    },
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.syncSelectedPetTypeId(newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.pet-type-selector__select {
  width: 100%;
}
</style>